import Footer from "components/footer";
import Header from "components/header";
import React from "react";

export default function DefaultLayout({ children }) {
  return (
    <div className="container relative h--100">
      <Header />
      <div
        style={{
          minHeight: "var(--min-height-body)",
          marginTop: "var(--height-menu)",
        }}
        className="mx-3"
      >
        {children}
      </div>
      <Footer />
    </div>
  );
}
